import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import './faq.css';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { faqData } from '../../data/faqData';

const PAGE_URL = 'https://www.snageasy.in/home-inspection-faq';
const PAGE_TITLE = 'Home Inspection FAQ | Common Questions Answered | SnagEasy';
const PAGE_DESC = 'Find answers to frequently asked questions about home inspection — what\'s covered, process, time, cost, RERA compliance, and more. Expert answers from SnagEasy.';

const Faq = () => {
  const { header, faqs } = faqData;
  const location = useLocation();
  const isStandalonePage = location.pathname === '/home-inspection-faq';

  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleAnswer = (index) => {
    setExpandedIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(({ question, answer }) => ({
      '@type': 'Question',
      name: question,
      acceptedAnswer: { '@type': 'Answer', text: answer },
    })),
  };

  return (
    <>
      {isStandalonePage && (
        <Helmet>
          <title>{PAGE_TITLE}</title>
          <meta name="description" content={PAGE_DESC} />
          <meta name="robots" content="index, follow" />
          <meta property="og:title" content={PAGE_TITLE} />
          <meta property="og:description" content={PAGE_DESC} />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={PAGE_URL} />
          <meta property="og:site_name" content="SnagEasy" />
          <meta name="twitter:card" content="summary" />
          <meta name="twitter:title" content={PAGE_TITLE} />
          <meta name="twitter:description" content={PAGE_DESC} />
          <link rel="canonical" href={PAGE_URL} />
          <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
        </Helmet>
      )}
    <div className="faq-section" id="faq">
      <div className="faq-container">
        {/* Header Section */}
        <div className="faq-header">
          <div className="faq-badge">
            <HelpOutlineIcon className="badge-icon" />
            <span>{header.badge.text}</span>
          </div>
          <h1 className="faq-title">{header.title}</h1>
          <p className="faq-description">
            {header.description}
          </p>
        </div>

        {/* FAQ Items */}
        <div className="faq-items">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-item ${expandedIndex === index ? 'expanded' : ''}`}
            >
              <div className="faq-question" onClick={() => toggleAnswer(index)}>
                <div className="question-content">
                  <div className="question-text">{faq.question}</div>
                  <div className="question-category">{faq.category}</div>
                </div>
                <div className="expand-icon">
                  {expandedIndex === index ? (
                    <ExpandLessIcon className="icon" />
                  ) : (
                    <ExpandMoreIcon className="icon" />
                  )}
                </div>
              </div>
              <div className={`faq-answer ${expandedIndex === index ? 'expanded' : ''}`}>
                <div className="answer-content">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
    </>
  );
};

export default Faq;
